import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './style.scss';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import AddressActions from '@Actions/addressActions';
import {
  EditOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import NewAddressForm from '@Components/Common/FormUtils/NewAddressForm';
import UpdateAddressForm from '@Components/Common/FormUtils/UpdateAddressForm';

/**
 *
 */
class VendorAddresses extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.selectedSeller?.seller_id !== state.selectedSeller?.seller_id) {
      props.getAddresses(1, props.selectedSeller?.seller_info?.seller_id, 'SELLER');
      return {
        ...state,
        selectedSeller: props.selectedSeller,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      selectedSeller, sellerAddresses, user, getAddresses, getAddressesLoading,
    } = this.props;
    const {
      showNewAddressModal, selectedAddress, showUpdateAddressModal,
    } = this.state;
    return (
      <Fragment>
        <Drawer
          open={showNewAddressModal}
          onClose={() => this.setState({ showNewAddressModal: false, selectedAddressType: '' })}
          width="360"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '311px' }}>
              <H3Text text="Add New Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewAddressModal: false })} />
            </div>
          </div>
          <NewAddressForm
            entityType="SELLER"
            entityId={selectedSeller?.seller_id}
            user={user}
            seller={selectedSeller}
            callback={
              () => {
                this.setState({ showNewAddressModal: false });
                getAddresses(1, selectedSeller?.seller_id, 'SELLER');
              }
            }
            tenantId={user?.tenant_info?.tenant_id}
          />
        </Drawer>
        <Drawer
          open={showUpdateAddressModal}
          onClose={() => this.setState({ showUpdateAddressModal: false })}
          width="360"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '311px' }}>
              <H3Text text="Update Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateAddressModal: false })} />
            </div>
          </div>
          <UpdateAddressForm
            entityType="SELLER"
            entityId={selectedSeller?.seller_id}
            addressType="SELLER"
            user={user}
            addressObject={selectedAddress}
            seller={selectedSeller}
            callback={
              () => {
                this.setState({ showUpdateAddressModal: false, selectedAddressObject: null });
                getAddresses(1, selectedSeller.seller_id, 'SELLER');
              }
            }
            tenantId={user?.tenant_info?.tenant_id}
          />
        </Drawer>
        <div className="vendor-addresses__wrapper">
          <div className="vendor-addresses__header">
            <div className="vendor-addresses__heading">
              ADDRESSES
            </div>
            {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.UPDATE, user) && (
              <div className="vendor-addresses__sub" onClick={() => this.setState({ showNewAddressModal: true })}>
                + Add New
              </div>
            )}
          </div>
          <div className="vendor-addresses__comments">
            {getAddressesLoading
              ? (
                <React.Fragment>
                  {[1, 2]?.map((item) => (
                    <div key={item} className="business-overview__loader">
                      <div className="loadingBlock loader-line-user  vendor-addresses__comment" />
                    </div>
                  ))}

                </React.Fragment>
              )
              : (
                <React.Fragment>
                  {sellerAddresses?.addresses?.map((address) => (
                    <div key={address?.address_id} className="vendor-addresses__comment">
                      <div className="vendor-addresses__comment-message">
                        {address?.address1}
                        <br />
                        {`${address?.city}, ${address?.state} ${address?.postal_code}, ${address?.country}`}
                      </div>
                      <div className="vendor-addresses__comment-options">
                        {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.UPDATE, user) && (
                          <div
                            className="comment-option roundIconButton"
                            onClick={() => this.setState({ showUpdateAddressModal: true, selectedAddress: address })}
                          >
                            <EditOutlined />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              )}

          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, AddressReducer, SellerReducers,
}) => ({
  user: UserReducers.user,
  getSellerByIdLoading: SellerReducers.getSellerByIdLoading,
  selectedSeller: SellerReducers.selectedSeller,
  sellerAddresses: AddressReducer.sellerAddresses,
  getAddressesLoading: AddressReducer.getAddressesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getAddresses: (page, entityId, entityType, addressId) => dispatch(AddressActions.getAddresses(page, entityId, entityType, addressId)),
});

VendorAddresses.propTypes = {
  selectedSeller: PropTypes.any,
  user: PropTypes.any,
  sellerAddresses: PropTypes.any,
  getAddresses: PropTypes.func,
  getAddressesLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorAddresses));
